export { default } from './IframeBlock'
